import { render, staticRenderFns } from "./StudyCase.vue?vue&type=template&id=49490e9c&scoped=true&"
import script from "./StudyCase.vue?vue&type=script&lang=ts&"
export * from "./StudyCase.vue?vue&type=script&lang=ts&"
import style0 from "./StudyCase.vue?vue&type=style&index=0&id=49490e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49490e9c",
  null
  
)

export default component.exports